import styled, { css } from "styled-components";
import { setFlex, setPosition, generateMediaQueries } from "../variables/utils";
import { COLOURS, BORDERS } from "../variables/colours";
import {
  BREAKPOINTS,
  desktop,
  mobile,
  IPADBREAKPOINTS,
} from "../variables/breakpoints";

export const setFontStyle = id => {
  switch (id) {
    case 0:
      return css`
        font-family: outward-block;
        font-size: 30rem;
        line-height: 25rem;

        @media (max-width: ${BREAKPOINTS.lg}px) {
          font-size: 20rem;
          line-height: 20rem;
        }
        @media (max-width: ${BREAKPOINTS.sm}px) {
          font-size: 15rem;
          line-height: 12rem;
        }
        @media (max-width: ${BREAKPOINTS.xs}px) {
          font-size: 13rem;
          line-height: 10rem;
        }
        @media (max-width: ${BREAKPOINTS.xxs}px) {
          font-size: 11rem;
          line-height: 8rem;
        }
        @media (max-width: ${BREAKPOINTS.xxxs}px) {
          font-size: 9rem;
          line-height: 7rem;
        }
      `;
    case 1:
      return css`
        font-family: thunder-blacklc;
        font-size: 12rem;
        line-height: 9.5rem;
        letter-spacing: 0.15rem;

        @media (max-width: ${BREAKPOINTS.xs}px) {
          font-size: 11rem;
          line-height: 8.5rem;
        }
        @media (max-width: ${BREAKPOINTS.xxs}px) {
          font-size: 10rem;
          line-height: 7.5rem;
        }
        @media (max-width: ${BREAKPOINTS.xxxs}px) {
          font-size: 8rem;
          line-height: 6rem;
        }
      `;
    case 2:
      return css`
        font-family: being-regular;
        font-size: 30rem;
        line-height: 25rem;

        @media (max-width: ${BREAKPOINTS.lg}px) {
          font-size: 11rem;
          line-height: 8.5rem;
        }
        @media (max-width: ${BREAKPOINTS.sm}px) {
          font-size: 20rem;
          line-height: 20rem;
        }
        @media (max-width: ${BREAKPOINTS.xs}px) {
          font-size: 9rem;
          line-height: 7rem;
        }
        @media (max-width: ${BREAKPOINTS.xxs}px) {
          font-size: 7rem;
          line-height: 5.5rem;
        }
      `;
    default:
      return css`
        font-family: outward-block;
      `;
  }
};

export const setFontSubtitleStyle = id => {
  switch (id) {
    case 0:
      return css`
        font-family: outward-block;
        font-size: 6rem;
        line-height: 5rem;
        @media (max-width: ${BREAKPOINTS.xxl}px) {
          font-size: 5rem;
          line-height: 4rem;
          margin-top: 0.65rem;
        }
      `;
    case 1:
      return css`
        font-family: thunder-blacklc;
        font-size: 6rem;
        line-height: 5rem;
        letter-spacing: 0.15rem;
        @media (max-width: ${BREAKPOINTS.xxl}px) {
          font-size: 5rem;
          line-height: 4rem;
          margin-top: 0.65rem;
        }
      `;
    case 2:
      return css`
        font-family: being-regular;
        font-size: 6rem;
        line-height: 4.8rem;
        @media (max-width: ${BREAKPOINTS.xxl}px) {
          font-size: 5rem;
          line-height: 3.85rem;
          margin-bottom: 0.65rem;
        }
      `;
    default:
      return css`
        font-family: outward-block;
      `;
  }
};

export const LenisRoot = styled.div`
  height: 100vh;
  overflow: hidden;
  position: relative;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    height: 100%;
    overflow: auto;
  }
`;

export const LenisScroll = styled.div`
  min-height: 100%;
`;

export const FixedLayerContainer = styled.div`
  ${setPosition({ position: "fixed", top: "0", left: "0", zIndex: "10" })};
  min-height: 100vh;
  height: 100%;
  width: 100%;
  overflow: hidden;
  pointer-events: none;

  @media (max-width: ${BREAKPOINTS.sm}px) {
    ${setPosition({ position: "relative" })};
    pointer-events: auto;
    overflow: visible;
  }
`;

export const IndexWrapper = styled.div`
  position: relative;
  height: 100%;
`;

export const Wrapper = styled.div`
  height: 100%;
  width: 100%;
`;

export const MainLandingContainer = styled.div`
  ${setFlex({ align: "center", justify: "flex-start", direction: "column" })};
  width: 100%;
  height: 100%;
  height: 100vh;
  pointer-events: none;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    pointer-events: auto;
  }
`;

export const MainLandingImageContainer = styled.div`
  ${setPosition({ position: "absolute", zIndex: -1 })};
  width: 100%;
  height: 100vh;
  @media (max-width: ${BREAKPOINTS.md}px) {
    max-height: 95vh;
  }
  @media (max-width: ${BREAKPOINTS.sm}px) {
    border: 1px solid transparent;
    filter: brightness(0.95);
    border-radius: 15px;
    overflow: hidden;
    width: -webkit-fill-available;
    margin: 2.5%;
  }
`;

export const MainLandingImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(1);
  ${props => props.$desktop && desktop};
  ${props => props.$mobile && mobile};

  @media (max-width: ${BREAKPOINTS.md}px) {
    object-position: center top;
  }
  @media (max-width: ${BREAKPOINTS.sm}px) {
    filter: brightness(0.75);
  }
`;

export const LandingLogo = styled.img`
  width: auto;
  margin: 7.5rem 0 2rem 0;
  max-width: 100px;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    margin: 4rem 0 0 0;
  }
  @media (max-width: ${BREAKPOINTS.xs}px) {
    margin: ${props => (props.$isHSApp ? "6.5rem 0 0 0" : "2.5rem 0 0 0")};
  }
`;

export const LandingHeadingContainer = styled.div`
  ${setFlex({ align: "center", justify: "center" })};
  width: 100%;
  padding-bottom: 12.5rem;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    padding-bottom: 0;
  }
  ${props => props.$desktop && desktop};
  ${props => props.$mobile && mobile};
`;

export const LandingHeading = styled.h1`
  font-family: "akzidenz-grotesk-bold";
  font-size: 10rem;
  line-height: 8rem;
  text-transform: uppercase;
  text-align: center;
  margin: 0;
  color: ${COLOURS.primary.white};
  -webkit-text-stroke: 1px ${COLOURS.primary.black};

  @media (max-width: ${BREAKPOINTS.sm}px) {
    font-size: 6rem;
    line-height: 4.5rem;
  }
  @media (max-width: ${BREAKPOINTS.sm}px) {
    font-size: 5rem;
    line-height: 4rem;
  }
  @media (max-width: ${BREAKPOINTS.xxs}px) {
    font-size: 4rem;
    line-height: 3.15rem;
  }
`;

export const LandingParagraph = styled.div`
  font-family: "akzidenz-grotesk-bold";
  font-size: 1.5rem;
  line-height: 1.5rem;
  color: ${COLOURS.primary.white};
  -webkit-text-stroke: 1px ${BORDERS.tertiary};
  margin: 0;
  text-align: center;
  padding: 0 4rem 2rem 4rem;
  max-width 55vw;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    padding: 0 2rem;
    font-size: 1.25rem;
    line-height: 1.25rem;
  }
`;

export const LandingScrollingWrapper = styled.div`
  ${setFlex({ direction: "column", align: "center" })};
  width: 100%;
  max-width: 1500px;
  @media (max-width: ${BREAKPOINTS.xxxl}px) {
    max-width: 75vw;
  }
  @media (max-width: ${BREAKPOINTS.sm}px) {
    padding: 0 3rem;
  }
  @media (max-width: ${BREAKPOINTS.xs}px) {
    padding: 0;
    max-width: unset;
  }
`;

export const LandingHeadingWrapper = styled.div`
  ${setFlex({ direction: "column", align: "center" })};
  width: 100%;
`;

export const LandingScrollingContainer = styled.div`
  ${setPosition({ position: "relative" })};
  ${setFlex({ direction: "column", align: "center", justify: "flex-start" })};
  height: 70vh;
  overflow: hidden;

  -webkit-mask-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 10%,
    rgba(0, 0, 0, 1) 100%
  );
  mask-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 10%,
    rgba(0, 0, 0, 1) 100%
  );
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;

  @media (max-width: ${BREAKPOINTS.sm}px) {
    height: 100vh;
  }
  @media (max-width: ${BREAKPOINTS.xs}px) {
    height: 70vh;
  }
`;

export const ScrollingContainer = styled.div`
  ${setFlex({ direction: "column", align: "center", justify: "flex-start" })};
`;

export const LandingSubtitle = styled.div`
  ${setPosition({ position: "sticky", zIndex: 10 })};
  ${setFlex({ align: "center", justify: "center" })};
  width: 100%;
  padding-bottom: 5rem;
  ${props => props.$desktop && desktop};
  ${props => props.$mobile && mobile};
  @media (max-width: ${BREAKPOINTS.sm}px) {
    ${setPosition({ position: "relative" })};
    padding-bottom: 15rem;
  }
`;

export const LandingSubtitleHeadingContainer = styled.div`
  ${setPosition({ position: "absolute", bottom: "0" })};
  ${setFlex({ align: "baseline", justify: "center" })};
  width: 100%;
  height: 8vh;

  @media (max-width: ${BREAKPOINTS.sm}px) {
    ${setPosition({ position: "relative" })};
  }
  ${generateMediaQueries(IPADBREAKPOINTS)} {
    bottom: -10px;
  }
`;

export const LandingSubtitleHeading = styled.h1`
  ${props => setFontSubtitleStyle(props.$subtitleCount)};
  color: ${COLOURS.primary.white};
  text-transform: uppercase;
  font-weight: normal;
  margin: 0;
  white-space: nowrap;
`;

export const LandingSubtitleSceneContainer = styled.div`
  ${setFlex({})};
  width: 150px;
  height: 100%;
  @media (max-width: ${BREAKPOINTS.xxl}px) {
    width: 125px;
  }
`;

export const LandingContainer = styled.div`
  ${setFlex({ align: "center" })};
  ${setPosition({ position: "fixed", zIndex: 15 })};
  height: 100%;
  width: 100%;
  padding-left: 1rem;
  pointer-events: none;
  opacity: 0;
  &.active {
    opacity: 1;
  }
  ${desktop};
`;

export const NavigationItem = styled.div`
  ${setPosition({ position: "absolute" })};
  cursor: pointer;
  will-change: transform;
`;

export const NavigationImage = styled.img`
  ${props => `aspect-ratio: ${props.$aspectRatio}`};
  width: auto;
  max-width: 50%;
`;

export const SectionWrapper = styled.div`
  ${setFlex({ align: "flex-end", justify: "flex-end" })};
  width: 100vw;
  height: 100vh;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    ${setFlex({ justify: "flex-start" })};
    height: ${props => (props.$isHSWeb ? "100svh" : "95svh")};
  }
`;

export const SectionTitle = styled.div`
  ${setFlex({ align: "flex-end", justify: "flex-end" })};
  overflow: visible;
  gap: 1rem;
  margin: 0 1rem;
  height: 35vh;
  ${props => props.$desktop && desktop};
  ${props =>
    props.$mobile &&
    css`
      ${mobile};
      @media (max-width: ${BREAKPOINTS.sm}px) {
        ${setFlex({ align: "flex-start", direction: "column" })};
      }
    `};
  @media (max-width: ${BREAKPOINTS.xxl}px) {
    height: 30vh;
  }
  @media (max-width: ${BREAKPOINTS.sm}px) {
    padding: 2rem 2rem 1.5rem 2rem;
    width: -webkit-fill-available;
  }
  @media (max-width: ${BREAKPOINTS.xs}px) {
    padding: 1rem;
  }
`;

export const SectionTitleText = styled.h2`
  ${props => setFontStyle(props.$articleId)};
  ${props => props.$fontColor && `color: ${props.$fontColor};`};
  text-transform: uppercase;
  font-weight: normal;
  margin: 0;
`;

export const SectionFooterContainer = styled.div`
  ${setFlex({ align: "flex-start" })};
  width: 100%;
  ${props => props.$mobile && mobile};
`;

export const SectionFooterLogo = styled.img`
  width: auto;
  padding-right: 5rem;
`;

export const SectionFooterTextContainer = styled.div`
  ${setFlex({
    align: "flex-start",
    justify: "flex-start",
    direction: "column",
  })};
`;

export const SectionFooterText = styled.p`
  font-family: "ibmplexmono-thin";
  font-size: 0.8rem;
  line-height: 1rem;
  margin: 0;
  text-transform: uppercase;
  font-weight: bold;
`;

export const SVGWrapper = styled.div`
  height: 100%;
  svg {
    height: 100%;
    display: block;
    overflow: visible;
    @media (max-width: ${BREAKPOINTS.xs}px) {
      width: 100%;
    }
  }
`;

export const SVGHeadingWrapper = styled(SVGWrapper)`
  height: 100%;
  width: 100%;
  max-width: ${props => (props.$maxWidth ? "1500px" : "100%")};
  @media (max-width: ${BREAKPOINTS.sm}px) {
    ${setFlex({
      align: "center",
      justify: "center",
    })};
    max-width: 70vw;
    ${props => props.$padding && `padding: 0 3.25rem;`};
  }
  @media (max-width: ${BREAKPOINTS.xs}px) {
    max-width: 95vw;
    ${props => props.$padding && `padding: 0 2rem;`};
  }
`;

export const LandingHoverWrapper = styled.div`
  ${setPosition({ position: "absolute" })};
  filter: blur(10px);
  height: 100%;
  width: 100%;
  transform-style: preserve-3d;
  backface-visibility: hidden;
`;
